import relationships from 'Consts/Relationships';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { currency } from 'Helpers/Formats';
import { QuestionnaireGoalOverride } from 'Overrides/GoalFieldList';
import { fullDate } from 'Consts/DateFormats';
import featureEnabled from './Affordances';

export const goalToLabel = (goal) => {
  const typePrompt = goal
    .meta()
    .field('type')
    .selectedOption()
    .attr('prompt');
  const description = goal.attr('description');
  const amount = goal.attr('amount');

  //  This can be null due to migrated old goals having no values set here.
  const timeHorizon = goal
    .meta()
    .field('timeHorizonType')
    .selectedOption()
    ? ` - ${goal.attr('timeHorizonValue')} ${goal
      .meta()
      .field('timeHorizonType')
      .selectedOption()
      .attr('prompt')}`
    : '';

  let result = `${typePrompt}`;
  if (description && description !== '') {
    result += ` - ${description}`;
  }
  result += ` - ${currency(Number(amount), true)} ${timeHorizon}`;
  return result;
};

export const goalToLabelNameAndEndDate = (goal) => {
  const typePrompt = goal
    .meta()
    .field('type')
    .selectedOption()
    .attr('prompt');
  const name = goal.attr('name');
  const amount = goal.attr('amount');
  const endDate = goal.attr('endDate');

  let result = `${typePrompt}`;
  if (name && name !== '') {
    result += ` - ${name}`;
  }
  result += ` - ${currency(Number(amount), true)} ${endDate ? `- ${moment(endDate).format(fullDate)}` : ''}`;
  return result;
};

export const goalResourcesToRecords = goalResources => goalResources.map(goalResource => ({
  goalResource,
  id: goalResource.id(),
}));
export const fetchGoals = (setCollectionData, householdResource) => householdResource
  .relationship(relationships.goals)
  .link('related')
  .Get({ metaOverrideSet: featureEnabled(householdResource, relationships.goalsPageAndBanner) ? QuestionnaireGoalOverride : null })
  .then((coll) => {
    setCollectionData(coll);
  })
  .catch((err) => {
    displayErrorMessage(err, err.errors);
  });
export const saveGoal = (goal, setCollectionData, refreshCollection) => goal
  .submit()
  .then(() => NotificationManager.success('Your information has been saved.'))
  .then(() => refreshCollection())
  .catch((err) => {
    displayErrorMessage(err, err.errors);
  });
export const removeGoal = (goalID, goals) => {
  const goalToDelete = goals.find(item => item.id() === goalID);
  return goalToDelete.delete().catch((err) => {
    displayErrorMessage(err, err.errors);
  });
};

export const getMetaValue = (collection, templateType, id) => {
  const mta = collection.meta();
  const field = mta.field(templateType);
  const option = field.option(id);
  return option.attr('prompt');
};
